// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__2bmRN","verticalCenter":"Icon_verticalCenter__24PD3"};